
import { unwrap, bind, map, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { getTriggerTypeLabel } from "../Form/View.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog as Dialog_1 } from "../../Components/Dialog.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { empty as empty_1, toArray, tryFind, singleton as singleton_1, ofArray, map as map_1, isEmpty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { WarningAlert } from "../../Components/Alert.js";
import { Button, TextButton } from "../../Components/Button.js";
import { Msg } from "./Types.js";
import { RouterModule_encodeParts, RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Select } from "../../Components/Select.js";
import { Skeleton } from "../../Components/Skeleton.js";
import { Permission, Permissions_has } from "../../Shared/Roles.js";
import { usePermissions } from "../../UserPermissions.js";
import { BoxHeader } from "../../Components/Text.js";
import { TableContainer } from "../../Widgets/Container.js";
import { Table } from "../../Widgets/Table/Table.js";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";

const importFileInputId = "procedure-template-import-file-input";

function hintText(t, i18n, hint) {
    const elementLabel = defaultArg(hint.ElementLabel, "");
    const triggerType_1 = defaultArg(map((triggerType) => getTriggerTypeLabel(t, triggerType), hint.TriggerType), "");
    let arg;
    const matchValue = hint.Kind;
    arg = ((matchValue.tag === 1) ? "procedure_template.import.hint.property_configuration_missing" : ((matchValue.tag === 2) ? "procedure_template.import.hint.information_field_skipped" : ((matchValue.tag === 3) ? "procedure_template.import.hint.image_missing" : ((matchValue.tag === 4) ? "procedure_template.import.hint.category_missing" : ((matchValue.tag === 5) ? "procedure_template.import.hint.role_missing" : ((matchValue.tag === 6) ? "procedure_template.import.hint.target_state_missing" : ((matchValue.tag === 7) ? "procedure_template.import.hint.email_user_missing" : "procedure_template.import.hint.inspection_template_missing")))))));
    const arg_1 = {
        element: elementLabel,
        name: hint.Name,
        trigger: triggerType_1,
    };
    return i18n.t(arg, arg_1);
}

function ImportResultDialog(props) {
    let Title, elems_2;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const i18n = patternInput[1];
    const matchValue = props.ImportResult;
    if (matchValue != null) {
        const result = matchValue;
        return createElement(Dialog_1, (Title = t("procedure_template.import.result_title"), {
            Body: singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4", "max-w-xl"])], ["data-test-id", "procedure-template-import-result"], (elems_2 = toList(delay(() => {
                let arg_1;
                return append(singleton(reactElement("p", {
                    children: (arg_1 = {
                        name: result.Name,
                    }, i18n.t("procedure_template.import.result_description", arg_1)),
                })), delay(() => {
                    let elems_1, elems;
                    const matchValue_1 = result.Hints;
                    return isEmpty(matchValue_1) ? singleton(defaultOf()) : singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_1 = [createElement(WarningAlert, {
                        Label: t("procedure_template.import.hints_title"),
                    }), reactElement("ul", createObj(ofArray([["className", join(" ", ["list-disc", "pl-5", "text-sm", "flex", "flex-col", "gap-1"])], ["data-test-id", "procedure-template-import-hints"], (elems = map_1((hint) => reactElement("li", {
                        children: hintText(t, i18n, hint),
                    }), matchValue_1), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))),
            Controls: ofArray([createElement(TextButton, {
                ComponentState: "enabled",
                Label: t("general.close"),
                OnClick: () => {
                    props.Dispatch(new Msg(4, []));
                },
                TestId: "procedure-template-import-close-button",
                Variant: "default",
            }), createElement(Button, {
                ComponentState: "enabled",
                Label: t("procedure_template.import.open_template"),
                OnClick: () => {
                    props.Dispatch(new Msg(4, []));
                    RouterModule_nav(ofArray(["procedure-templates", result.ProcedureTemplateId]), 1, 1);
                },
                TestId: "procedure-template-import-open-button",
                Variant: "primary",
            })]),
            IsOpen: true,
            OnClose: () => {
                props.Dispatch(new Msg(4, []));
            },
            Title: Title,
        }));
    }
    else {
        return defaultOf();
    }
}

function PredefinedTemplatesDialog(props) {
    let Title, elems_1;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const matchValue = props.Dialog;
    if (matchValue != null) {
        const dialog = matchValue;
        const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
        const templateOption = (template_1) => ({
            label: template_1.Name,
            value: template_1.Key,
        });
        return createElement(Dialog_1, (Title = t("procedure_template.predefined.dialog_title"), {
            Body: singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-5", "max-w-xl"])], ["data-test-id", "predefined-procedure-templates-dialog"], (elems_1 = toList(delay(() => append(singleton(reactElement("p", {
                children: t("procedure_template.predefined.dialog_description"),
            })), delay(() => {
                const matchValue_2 = dialog.Templates;
                if (matchValue_2.tag === 1) {
                    const templates = matchValue_2.fields[0];
                    const selectedTemplate = bind((key_16) => tryFind((template_2) => (template_2.Key === key_16), templates), dialog.SelectedKey);
                    return append(singleton(createElement(Select, {
                        ComponentState: componentState,
                        IsClearable: true,
                        Label: t("procedure_template.predefined.select_label"),
                        NoOptionsMessage: "procedure_template.predefined.no_templates",
                        OnChange: (selected) => {
                            props.Dispatch(new Msg(7, [map((_arg) => _arg.value, selected)]));
                        },
                        Options: map_1(templateOption, templates),
                        PlaceholderKey: "general.select",
                        TestId: "predefined-procedure-templates-select",
                        Value: unwrap(map(templateOption, selectedTemplate)),
                    })), delay(() => {
                        let template, elems;
                        const matchValue_3 = selectedTemplate;
                        return (matchValue_3 == null) ? singleton(defaultOf()) : singleton((template = matchValue_3, reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1", "-mt-3"])], ["data-test-id", concat("predefined-procedure-template-row-", ...template.Key)], (elems = toList(delay(() => append(singleton(reactElement("p", {
                            className: join(" ", ["text-sm", "text-text-muted"]),
                            children: template.Description,
                        })), delay(() => {
                            let matchValue_1, arg_1;
                            return append((matchValue_1 = template.InspectionTemplateNames, isEmpty(matchValue_1) ? singleton(defaultOf()) : singleton(reactElement("p", {
                                className: join(" ", ["text-xs", "text-text-muted"]),
                                children: (arg_1 = {
                                    name: join(", ", matchValue_1),
                                }, patternInput[1].t("procedure_template.predefined.inspection_template_hint", arg_1)),
                            }))), delay(() => (template.AlreadyExists ? singleton(reactElement("p", {
                                className: join(" ", ["text-xs", "text-text-muted"]),
                                "data-test-id": "predefined-procedure-templates-existing",
                                children: t("procedure_template.predefined.already_existing_hint"),
                            })) : empty())));
                        })))), ["children", reactApi.Children.toArray(Array.from(elems))])])))));
                    }));
                }
                else {
                    return singleton(createElement(Skeleton, {
                        Variant: "normal",
                    }));
                }
            })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))),
            Controls: ofArray([createElement(TextButton, {
                ComponentState: componentState,
                Label: t("general.close"),
                OnClick: () => {
                    props.Dispatch(new Msg(10, []));
                },
                TestId: "predefined-procedure-templates-close-button",
                Variant: "default",
            }), createElement(Button, {
                ComponentState: (dialog.SelectedKey == null) ? "disabled" : componentState,
                Label: t("procedure_template.predefined.load_button"),
                OnClick: () => {
                    props.Dispatch(new Msg(8, []));
                },
                TestId: "predefined-procedure-templates-load-button",
                Variant: "primary",
            })]),
            IsOpen: true,
            OnClose: () => {
                props.Dispatch(new Msg(10, []));
            },
            Title: Title,
        }));
    }
    else {
        return defaultOf();
    }
}

export function OverviewTable(props) {
    let elems_4;
    const t = useTranslation()[0];
    const canImport = Permissions_has(usePermissions(), new Permission(94, []));
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "grow"])], (elems_4 = toList(delay(() => {
        let elems_1, elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "mb-3", "justify-items-end"])], (elems_1 = [reactElement("div", {
            className: join(" ", ["grow"]),
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["justify-self-end", "flex", "gap-3"])], (elems = toList(delay(() => append(canImport ? append(singleton(createElement(TextButton, {
            ComponentState: componentState,
            Label: t("procedure_template.predefined.button"),
            OnClick: () => {
                props.Dispatch(new Msg(5, []));
            },
            TestId: "procedure-template-overview-load-predefined-button",
            Variant: "default",
        })), delay(() => append(singleton(reactElement("input", {
            id: importFileInputId,
            className: join(" ", ["hidden"]),
            type: "file",
            accept: ".json,application/json",
            "data-test-id": importFileInputId,
            disabled: props.FormState.IsLoading,
            onChange: (ev) => {
                const files = ev.target.files;
                if (!(files == null) && (files.length > 0)) {
                    props.Dispatch(new Msg(1, [files.item(0)]));
                }
            },
        })), delay(() => singleton(createElement(TextButton, {
            ComponentState: componentState,
            Label: t("procedure_template.import.button"),
            OnClick: () => {
                const element = document.getElementById(importFileInputId);
                element.value = "";
                element.click();
            },
            TestId: "procedure-template-overview-import-button",
            Variant: "default",
        })))))) : empty(), delay(() => singleton(createElement(Button, {
            ComponentState: "enabled",
            Label: t("procedure_template.overview.create_new_button_title"),
            OnClick: () => {
                RouterModule_nav(ofArray(["procedure-templates", "new"]), 1, 1);
            },
            TestId: "procedure-template-overview-new-checklist-button",
            Variant: "primary",
        })))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let elems_3, elems_2, TableRows;
            return isEmpty(props.ProcedureTemplates) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3", "bg-white", "rounded", "p-6"])], ["data-test-id", "procedure-template-overview-empty-state"], (elems_3 = [createElement(BoxHeader, {
                Text: t("procedure_template.predefined.empty_state_title"),
            }), reactElement("p", {
                className: join(" ", ["text-text-muted"]),
                children: t("procedure_template.predefined.empty_state"),
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "justify-end", "gap-2"])], (elems_2 = toList(delay(() => append(canImport ? singleton(createElement(Button, {
                ComponentState: componentState,
                Label: t("procedure_template.predefined.button"),
                OnClick: () => {
                    props.Dispatch(new Msg(5, []));
                },
                TestId: "procedure-template-overview-load-predefined-button-empty",
                Variant: "secondary",
            })) : empty(), delay(() => singleton(createElement(Button, {
                ComponentState: "enabled",
                Label: t("procedure_template.overview.create_new_button_title"),
                OnClick: () => {
                    RouterModule_nav(ofArray(["procedure-templates", "new"]), 1, 1);
                },
                TestId: "procedure-template-overview-new-checklist-button-empty",
                Variant: "primary",
            })))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : singleton(createElement(TableContainer, {
                Content: createElement(Table, (TableRows = toArray(props.ProcedureTemplates), {
                    ColumnDefinitions: [new ColumnDefinition$1("title", "", t("general.title"), (dto) => (new CellContent(0, [dto.Title])), "text", "text"), new ColumnDefinition$1("description", "", t("general.description"), (dto_1) => (new CellContent(0, [dto_1.Description])), "text", "text"), new ColumnDefinition$1("state", "", t("procedure.form.state"), (dto_2) => {
                        let matchValue;
                        return new CellContent(0, [(matchValue = dto_2.State, (matchValue.tag === 2) ? t("procedure.state.released") : ((matchValue.tag === 1) ? t("procedure.state.archived") : t("procedure.state.draft")))]);
                    }, "select", "text"), new ColumnDefinition$1("createdAt", "", t("general.created_at"), (dto_3) => (new CellContent(8, [dto_3.CreatedAt])), "dateRange", "date")],
                    Controls: empty_1(),
                    Options: {
                        BorderStyle: "full",
                        CSVDownload: false,
                        ConfigurableColumns: false,
                        CustomTableFilters: false,
                        DefaultColumnFilter: singleton_1({
                            id: "state",
                            value: [t("procedure.state.released"), t("procedure.state.draft")],
                        }),
                        DefaultSortColumn: ["createdAt", "desc"],
                        Fullscreen: false,
                        GlobalSearch: false,
                        OnRowClick: new OnTableRowClick$1(1, [(procedureTemplate) => RouterModule_encodeParts(ofArray(["procedure-templates", procedureTemplate.Id]), 1)]),
                        RowSelection: "disabled",
                        SaveTableConfiguration: false,
                    },
                    TableKey: "procedure-templates-overview",
                    TableRows: TableRows,
                })),
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

export function OverviewView() {
    let elems;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "grow"])], (elems = toList(delay(() => {
        let matchValue;
        return append((matchValue = state_1.ProcedureTemplates, (matchValue.tag === 0) ? singleton(createElement(Skeleton, {
            Variant: "table",
        })) : singleton(createElement(OverviewTable, {
            Dispatch: dispatch,
            FormState: state_1.FormState,
            ProcedureTemplates: matchValue.fields[0],
        }))), delay(() => append(singleton(createElement(ImportResultDialog, {
            Dispatch: dispatch,
            ImportResult: unwrap(state_1.ImportResult),
        })), delay(() => singleton(createElement(PredefinedTemplatesDialog, {
            Dialog: unwrap(state_1.PredefinedDialog),
            Dispatch: dispatch,
            FormState: state_1.FormState,
        }))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

